import { SecurityOidcService } from '../services/system/security.oidc.service';
import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { AppContextService } from '../../services/sji.appcontext.service';
/**
 * Any http request send out, application auto includes current login user's oauth2 token in the http request's header.
 * Further, application includes current running language's culture code in the http request's header.
 * Work for server side authentication and multiple languages support.
 * Assess token got from Identity Server 4.
 */
@Injectable()
export class SecurityOidcInterceptor implements HttpInterceptor {
    constructor(private securityService: SecurityOidcService,
      private appContextService: AppContextService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //
        // Add authorization header with jwt token if available.
        //
        //
        // If there is logon user, check logon user's prefer language.
        //
        // Note: All header values must be strings. Convert to string to avoid "Spread syntax requires ...iterable" error.
        const companyId = String(this.securityService.getCompanyId() || '0');
        const currentLanguage = String(this.securityService.getAppContextDefaultLanguage() || 'en-us');
        const timeZoneOffset = String(this.appContextService.timeZoneOffset || '0');

        if (this.securityService.isLoggedIn()) {
          //console.log("SecurityOidInterceptor called. IsLoggedIn. access token: " + this.securityService.getAuthorizationHeaderValue());

          request = request.clone({
             // tslint:disable-next-line:max-line-length
             setHeaders: {
               authorization: this.securityService.getAuthorizationHeaderValue(),
               currentLanguage: currentLanguage,
               // Passing current processing company's Id back to server side.
               companyId: companyId,
               timeZoneOffset: timeZoneOffset
              }
          });
        } else {
           // If there is no logon user, system still need to pass default langauge as culture code back to server side.
           request = request.clone({
              setHeaders: {
                currentLanguage: currentLanguage,
                companyId: companyId,
                timeZoneOffset: timeZoneOffset
              }
           });
        }

     return next.handle(request).do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Do stuff with response if you want.
        }
      }, (err: any) => {
        if ( err instanceof HttpErrorResponse ) {
          if ( err.status === 401 ) {
              // this.securityService.login();
              // Note: Now, HttpErrorInterceptor  take care the error.
          }
        }
      });
   }
  }

/**
 * Provider POJO for the oidc interceptor
 */
export const SecurityOidcInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: SecurityOidcInterceptor,
  multi: true
};
